import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import InputDatePicker from 'components/common/InputDatePicker';

const ExportBar = ({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  onExport,
  isExporting,
  disabled
}) => {
  const handleChange = (column, value) => {
    if (column === 'fromDate') setFromDate(value);
    if (column === 'toDate') setToDate(value);
  };

  const isDisabled = !fromDate || !toDate || isExporting || disabled;

  return (
    <Row className="g-2">
      <Col xs={12} sm={6} md={4} lg={3}>
        <InputDatePicker
          column="fromDate"
          displayName="From Date"
          selected={fromDate}
          handleChange={handleChange}
        />
      </Col>

      <Col xs={12} sm={6} md={4} lg={3}>
        <InputDatePicker
          column="toDate"
          displayName="To Date"
          selected={toDate}
          handleChange={handleChange}
        />
      </Col>

      <Col
        xs={12}
        sm={6}
        md={4}
        lg={2}
        className="d-flex align-items-end justify-content-start"
      >
        <Button className="w-100" onClick={onExport} disabled={isDisabled}>
          {isExporting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" />
              Exporting...
            </>
          ) : (
            'Export'
          )}
        </Button>
      </Col>
    </Row>
  );
};

ExportBar.propTypes = {
  fromDate: PropTypes.any,
  toDate: PropTypes.any,
  setFromDate: PropTypes.func.isRequired,
  setToDate: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
  isExporting: PropTypes.bool,
  disabled: PropTypes.bool
};

ExportBar.defaultProps = {
  isExporting: false,
  disabled: false
};

export default ExportBar;
